// Dati identificativi del titolare: unico punto da compilare per tutte le pagine legali.
// Lasciando un campo vuoto, nel documento compare una riga da completare.
export const COMPANY_LEGAL = {
  legalName: "",
  vatNumber: "",
  fiscalCode: "",
  address: "",
  court: "",
  supportEmail: "",
  privacyEmail: "",
  dpo: "",
  rea: "",
  pec: "",
};

export const blank = (length = 24) => "_".repeat(length);

export const legalField = (value, length) => (value && value.trim() ? value.trim() : blank(length));
